import React, { useMemo, useState } from "react";
import { CourseItem } from "../../../../API";
import WeekPicker from "./components/WeekPicker";
import DayPicker from "./components/DayPicker";
import DayCalendar from "./components/DayCalendar";
import BatchPicker from "./components/BatchPicker";
import style from "./index.module.scss";
import useWeekCalendar from "../../utils/useWeekCalendar";
import { Spin } from "antd";
import useCurrentDate from "../../../../Utils/useCurrentDate";
import _ from "underscore";
import useWeekPicker from "../../utils/useWeekPicker";

interface DayItems {
    day: string;
    courses: CourseItem[];
    date: string;
}

interface MainMobileProps {
    week: number;
    currentWeek: number;
    onWeekChange: (week: number) => void;
    startDate: string;
    endDate: string;
    loading: boolean;
    data: DayItems[];
}

export default function MainMobile({
    week,
    currentWeek,
    data,
    loading,
    onWeekChange,
    startDate,
    endDate
}: MainMobileProps) {
    const { time } = useCurrentDate();
    const { isCurrentBatch } = useWeekPicker(week, onWeekChange);

    // 当前选择的星期几
    const [selectedWeekDay, setSelectedWeekDay] = useState(time.isoWeekday());
    const { weekDays } = useWeekCalendar({ data, startDate, endDate });

    const selectCourses = useMemo(() => {
        const course =
            _.find(data, { day: (selectedWeekDay - 1).toString() })?.courses ||
            [];
        return course.filter(item => !!item);
    }, [data, selectedWeekDay]);

    const selectDate = useMemo(() => {
        const date =
            _.find(data, { day: (selectedWeekDay - 1).toString() })?.date || "";
        return date;
    }, [data, selectedWeekDay]);

    function resetWeekHandler() {
        onWeekChange(currentWeek);
        setSelectedWeekDay(time.isoWeekday());
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <BatchPicker
                    showResetBtn={isCurrentBatch}
                    onResetWeek={resetWeekHandler}
                    showCourseListLink
                />
                <WeekPicker week={week} onChange={onWeekChange} />
                <DayPicker
                    days={weekDays}
                    weekDay={selectedWeekDay}
                    onChange={setSelectedWeekDay}
                />
            </div>

            <div className={style.body}>
                <Spin spinning={loading}>
                    <DayCalendar
                        courses={selectCourses}
                        dateTime={selectDate}
                    />
                </Spin>
            </div>
        </div>
    );
}
